//this us a replica of kaizen component. (Beaconstac options)
import { Component, EventEmitter, Input, Output } from '@angular/core';

export enum OPTIONS_POSITION {
    TOP = 'dropdown-on-top',
    BOTTOM = 'dropdown-on-bottom',
}

@Component({
    selector: 'options-component',
    templateUrl: './options.component.html',
    styleUrl: './options.component.scss',
    standalone: false
})
export class OptionsComponent {
    /**
     * width of list
     */
    @Input()
    maxWidth: string;

    /**
     * custom class for orientation handling
     */
    @Input()
    optionsPosition: OPTIONS_POSITION;

    /**
     * height of list
     */
    @Input()
    maxHeight: string;

    /**
     * Label field from custom object
     */
    @Input()
    optionLabelField = 'name';

    /**
     * Value field from custom object
     */
    @Input()
    optionValueField = 'value';

    /**
     * Secondary value field from custom object
     */
    @Input()
    optionSecondaryLabelField = 'secondaryValue';

    /**
     * Content of list
     */
    @Input()
    listItems = [];

    /**
     * Selected value
     */
    @Input()
    value: any;

    /**
     * Value change emitter
     */
    @Output()
    valueChange: EventEmitter<any> = new EventEmitter<any>();

    /**
     * If specific output is required from custom object
     */
    @Input()
    specificOutput = '';

    /**
     * Specific output emitter
     */
    @Output()
    specificOutputChange = new EventEmitter<any>();

    /**
     * Should highlight selected value or not
     */
    @Input()
    highlightSelectedValue = true;

    @Input()
    optionsType = 1;

    @Input()
    isFetchingData = false;

    @Input()
    enableInfiniteScrolling = false;
    /*
     * optionsHeader is used to display a header in the options dropdown
     */
    @Input()
    optionsHeaderText = '';

    @Output()
    fetchMoreData: EventEmitter<null> = new EventEmitter();

    onModalScrollDown() {
        if (this.enableInfiniteScrolling) {
            this.fetchMoreData.emit();
        }
    }
    setValue(item) {
        if (!item.hasOwnProperty('isHeader')) {
            if (
                item.hasOwnProperty('isClickable') &&
                item.isClickable === false
            ) {
                return;
            }
            this.value = item;
            this.valueChange.next(this.value);
            if (this.specificOutput) {
                this.specificOutputChange.emit(this.value[this.specificOutput]);
            }
        }
    }
}
